import React from 'react';
import { useReactFlow } from '@xyflow/react';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { ColorPicker } from '../../../../components/ColorPicker';

export default function AgeRangeContextMenu({
  id,
  top,
  left,
  right,
  bottom,
  setOpenNewHouseDialog,
  setAgeRangeNodeData,
  onPaneClick,
  style,
  data,
  ...props
}) {
  console.log(style, data);
  const { getNode } = useReactFlow();
  const [selectedColor, setSelectedColor] = React.useState('#ffffff'); // Domyślny kolor
  const { updateNodeF, setShowComments } = useAccomodationDiagram();
  const node = getNode(id);

  const handleFixedNode = draggable => {
    const updatedNode = node;
    if (draggable) {
      const { draggable, ...restNode } = updatedNode;
      updateNodeF(restNode);
    } else {
      updatedNode.draggable = draggable;
      updateNodeF(updatedNode);
    }
    onPaneClick();
  };

  const handleColorChange = color => {
    const newColor = color.hex; // Nowy kolor z inputu
    setSelectedColor(newColor); // Ustaw nowy kolor

    // Wywołaj funkcję updateNode po wyborze koloru
    const node = getNode(id);
    if (node) {
      const updatedNode = {
        ...node,
        style: {
          ...node.style,
          backgroundColor: newColor // Zastosuj nowy kolor
        }
      };
      updateNodeF(updatedNode); // Zaktualizuj węzeł
      // onPaneClick();
    }
  };

  return (
    <div
      style={{ top, left, right, bottom }}
      className="context-menu"
      {...props}
    >
      <ColorPicker color={selectedColor} handleColorChange={handleColorChange} />
      <button onClick={() => {
        setOpenNewHouseDialog(true);
        setAgeRangeNodeData(getNode(id));
      }}>Dodaj domek</button>
      {node.draggable === false
        ? <button onClick={() => handleFixedNode(true)}>Odklej</button>
        : <button onClick={() => handleFixedNode(false)}>Przyklej</button>
      }
      <button onClick={() => setShowComments(true)}>Pokaż komentarze</button>
    </div>
  );
}
